import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import { TrackingProvider } from './context/TrackingContext';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Loads from './pages/Loads';
import LoadDetail from './pages/LoadDetail';
import VehicleDetail from './pages/VehicleDetail';
import VehicleInspection from './pages/VehicleInspection';
import Map from './pages/Map';
import Payments from './pages/Payments';
import PaymentDetail from './pages/PaymentDetail';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';

// Checks if the driver is logged in and redirects to the appropriate
// starting screen — /loads if logged in, /login if not.
function RootRedirect() {
  const token = localStorage.getItem('token');
  return <Navigate to={token ? '/loads' : '/login'} replace />;
}

function App() {
  return (
    <ToastProvider>
      <TrackingProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />

            <Route path="/loads" element={<ProtectedRoute><Loads /></ProtectedRoute>} />
            <Route path="/loads/:id" element={<ProtectedRoute><LoadDetail /></ProtectedRoute>} />
            <Route path="/loads/:loadId/vehicles/:vehicleId" element={<ProtectedRoute><VehicleDetail /></ProtectedRoute>} />
            <Route path="/loads/:id/inspection" element={<ProtectedRoute><VehicleInspection /></ProtectedRoute>} />
            <Route path="/map" element={<ProtectedRoute><Map /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/payments/:id" element={<ProtectedRoute><PaymentDetail /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </TrackingProvider>
    </ToastProvider>
  );
}

export default App;